import { useFeatureFlag } from '@qualio/ui-components';
import { WorkspaceTabs } from '../WorkspaceV2';
import { useParentCompanyName } from './useParentCompanyName';

type WorkspaceAccountFilter = {
  accountFilterApplies: boolean;
  parentCompanyName: string | undefined;
};

export const useWorkspaceAccountFilter = (
  tab: WorkspaceTabs,
): WorkspaceAccountFilter => {
  const featureFlags = useFeatureFlag();
  const accountFilterEnabled =
    Boolean(featureFlags['enterprise-accounts']) &&
    tab === WorkspaceTabs.ALL_DOCUMENTS;
  const { data: parentCompanyName } =
    useParentCompanyName(accountFilterEnabled);

  if (accountFilterEnabled && parentCompanyName !== null) {
    return { accountFilterApplies: true, parentCompanyName };
  }
  return { accountFilterApplies: false, parentCompanyName: undefined };
};
